import { Menu } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCheck, IconChecks, IconReport } from "@tabler/icons-react";
import { useNavigate, useParams } from "react-router-dom";
import { useIsExpired } from "src/generator/hooks/useIsExpired";
import { useWindowSize } from "src/hooks";
import { StyledBurger } from "src/styled";

import HistoricalSnapshotButton from "../../../components/pages/HistoricalSnapshot/HistoricalSnapshotButton";
import CheckListsButton from "../_Buttons/CheckListsButton";
import FilesButton from "../_Buttons/FilesButton";
import HistoryButton from "../_Buttons/HistoryButton";
import NewEntryButton from "../_Buttons/NewEntryButton";
import SaveEntryButton from "../_Buttons/SaveEntryButton";
import SearchButton from "../_Buttons/SearchButton";
import SortEntriesButton from "../_Buttons/SortEntriesButton";
import GlobalCollapseButton from "../../../components/shared/GlobalCollapseButton/GlobalCollapseButton";
import WithdrawButton from "../_Buttons/WithdrawButton";
import { useSelector } from "../../../redux/hooks";
import { ReadonlyFieldset } from "src/generator/Logbook/Logbook.styled";
import PdfEntryButton from "../_Buttons/PdfEntryButton";

const HamburgerMenu = () => {
  const [opened, { toggle }] = useDisclosure(false);
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const isExpiredLogbook = useIsExpired();
  const { lbentry } = useSelector(state => state.generatorSlice);
  const isReadOnly = useSelector(
    state => state.generatorSlice.lbentry.isReadonly,
  );
  const status = useSelector(state => state.generatorSlice.latestEntry.status);
  const { idType, lbeidOrPartId } = useParams();

  return (
    <>
      <Menu
        keepMounted
        onClose={toggle}
        shadow="md"
        width={200}
        position="left-start">
        <Menu.Target>
          <StyledBurger ml={15} opened={opened} onClick={toggle} />
        </Menu.Target>

        <Menu.Dropdown>
          {width <= 1080 && !isExpiredLogbook ? (
            <>
              <ReadonlyFieldset disabled={isReadOnly}>
                <SaveEntryButton hamburger />
                <NewEntryButton hamburger />
              </ReadonlyFieldset>
              <SearchButton hamburger />
              <GlobalCollapseButton hamburger />
              <SortEntriesButton hamburger />
              <Menu.Divider />
            </>
          ) : (
            lbentry.continousEntry && <NewEntryButton hamburger />
          )}
          <CheckListsButton />

          <Menu.Item
            onClick={() => navigate(`/summary`)}
            leftSection={<IconCheck size={20} />}>
            Summary
          </Menu.Item>
          <Menu.Item
            disabled={status === 3}
            onClick={() =>
              navigate(
                `/summary/verify-entries/${idType}/${lbeidOrPartId}?from=entry`,
              )
            }
            leftSection={<IconChecks size={20} />}>
            Quick Verify
          </Menu.Item>
          <Menu.Item
            onClick={() => navigate("/reports")}
            leftSection={<IconReport size={20} />}>
            Reports
          </Menu.Item>
          {lbentry.showPDFButton && <PdfEntryButton hamburger />}
          <Menu.Divider />
          <FilesButton hamburger />
          <HistoryButton hamburger />
          <HistoricalSnapshotButton />

          {!isExpiredLogbook && <WithdrawButton hamburger />}
        </Menu.Dropdown>
      </Menu>
    </>
  );
};

export default HamburgerMenu;
